'use strict';

const SoaModel = require('bunsen/models/SoaModel');
const tokenReplace = require('dibs-token-replace');
const verticals = require('dibs-vertical-helpers');
const priceMixin = require('../mixins/commonjs/price');

// URL's
const URI_SEARCH_QUERY = '/search/?q={query}&rt=save';
const URI_SEARCH_QUERY_PRICE =
    '/search/?q={query}&price=[1 TO {price}]&currency={currency}&rt=save';
const URI_ATTRIBUTE = '/{vertical}/{attributeType}/{attributeValue}/?rt=save';

const SaveSearchModel = SoaModel.extend({
    /**
     * @param {Object} payload
     * @returns {Promise}
     */
    getSaveSearchData(payload = {}) {
        return new Promise((resolve, reject) => {
            this.fetch({
                url: this.getSaveSearchUrl(payload),
            })
                .then(() => resolve(this.toJSON()))
                .fail(() => reject());
        });
    },

    /**
     * @param {Object} payload
     * @returns {String}
     */
    getSearchQueryUrl(payload = {}) {
        const { query, price } = payload;
        let { currency } = payload;
        const uri = price ? URI_SEARCH_QUERY_PRICE : URI_SEARCH_QUERY;
        currency = currency || priceMixin._currency.defaultCurrency;

        return tokenReplace(uri, { query, price, currency });
    },

    /**
     * @param {Object} payload
     * @returns {String}
     */
    getAttributeUrl(payload = {}) {
        const { attributeType, attributeValue } = payload;
        let { vertical } = payload;
        vertical = vertical || verticals.VERTICAL_FURNITURE;

        return tokenReplace(URI_ATTRIBUTE, { attributeType, attributeValue, vertical });
    },

    /**
     * @param {Object} payload
     * @returns {String}
     */
    getSaveSearchUrl(payload = {}) {
        if (payload.attributeType) {
            return this.getAttributeUrl(payload);
        }

        return this.getSearchQueryUrl(payload);
    },
});

module.exports = SaveSearchModel;



// WEBPACK FOOTER //
// ./assets/js/global/models/SaveSearchModel.es.js